export default "__VITE_ASSET__f28738fb__"